import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import KidsMoneyApp from "@/components/KidsMoneyApp";
import KidPickerPage from "@/pages/KidPickerPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import OnboardingPage from "@/pages/OnboardingPage";
import InstallPrompt from "@/components/InstallPrompt";

function Splash() {
  return (
    <div
      data-testid="auth-splash"
      className="min-h-screen flex items-center justify-center px-4"
    >
      <div className="chunky-card p-8 text-center" style={{ backgroundColor: "#FFC400" }}>
        <div className="font-display text-3xl text-navy">Loading...</div>
      </div>
    </div>
  );
}

function Home() {
  const { user, activeKidId } = useAuth();
  if (user === null) return <Splash />;
  if (user === false) return <Navigate to="/login" replace />;
  if (sessionStorage.getItem("km_first_run"))
    return <Navigate to="/how-it-works?first=1" replace />;
  return activeKidId ? <KidsMoneyApp /> : <KidPickerPage />;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Splash />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/login"
              element={
                <PublicOnly>
                  <LoginPage />
                </PublicOnly>
              }
            />
            <Route
              path="/signup"
              element={
                <PublicOnly>
                  <SignupPage />
                </PublicOnly>
              }
            />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/how-it-works" element={<OnboardingPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <InstallPrompt />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
